module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign"
  }, [_c('div', {
    staticClass: "sign_head"
  }, [_c('img', {
    staticClass: "sign_back",
    attrs: {
      "src": require("../../assets/images/sign/icon-back.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.replace(("/signclazz?outId=" + _vm.outId + "&clazzId=" + _vm.clazzId))
      }
    }
  }), _vm._v("学生签字\n    "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "sign_panel"
  }, [_c('div', {
    staticClass: "sign_panel-head"
  }, [_c('div', [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": require("../../assets/images/sign/icon-bj.png"),
      "alt": ""
    }
  }), _vm._v("\n        " + _vm._s(_vm.clazzName) + "\n        "), _c('span', {
    staticClass: "sign_panel-head-subtitle"
  }, [_vm._v("共" + _vm._s(_vm.studentNames.length) + "名学员")])])]), _vm._v(" "), _c('div', {
    staticClass: "sign_panel-body"
  }, [_c('div', {
    staticClass: "sign_item"
  }, [_c('span', {
    staticClass: "sign_item-label"
  }, [_vm._v("品目名称：")]), _vm._v(" "), _c('span', {
    staticClass: "sign_item-val"
  }, [_vm._v(_vm._s(_vm.outputDetail.itemName))])]), _vm._v(" "), _c('div', {
    staticClass: "sign_item"
  }, [_c('span', {
    staticClass: "sign_item-label"
  }, [_vm._v("领用日期：")]), _vm._v(" "), _c('span', {
    staticClass: "sign_item-val"
  }, [_vm._v(_vm._s(_vm.outDate))])])])]), _vm._v(" "), _c('div', {
    staticClass: "sign_panel"
  }, [_c('div', {
    staticClass: "sign_panel-head"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "sign_panel-head-subtitle"
  }, [_vm._v("数量：" + _vm._s(_vm.outputDetail.no))])]), _vm._v(" "), _c('div', {
    staticClass: "sign_panel-body sign_lyry"
  }, [_vm._l((_vm.studentNames), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index < 8 || _vm.showMore),
        expression: "index<8 || showMore"
      }],
      staticClass: "sign_item"
    }, [_c('span', [_vm._v(_vm._s(item))])])
  }), _vm._v(" "), (_vm.studentNames.length > 7 && _vm.showMore) ? _c('div', {
    staticClass: "sign_item sign_zkqb",
    on: {
      "click": function($event) {
        _vm.showMore = false
      }
    }
  }, [_c('img', {
    staticClass: "sign_icon",
    staticStyle: {
      "transform": "rotate(180deg)"
    },
    attrs: {
      "src": require("../../assets/images/sign/icon-zkgd.png"),
      "alt": ""
    }
  }), _vm._v("收起\n      ")]) : _vm._e(), _vm._v(" "), (_vm.studentNames.length > 7 && !_vm.showMore) ? _c('div', {
    staticClass: "sign_item sign_zkqb",
    on: {
      "click": function($event) {
        _vm.showMore = true
      }
    }
  }, [_c('img', {
    staticClass: "sign_icon",
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "src": require("../../assets/images/sign/icon-zkgd.png"),
      "alt": ""
    }
  }), _vm._v("展开全部\n      ")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "sign_panel"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "sign_panel-body"
  }, [_c('div', {
    staticClass: "qm",
    on: {
      "click": _vm.gotoSign
    }
  }, [(!_vm.url) ? [_c('img', {
    ref: "pImg",
    staticClass: "placeholeder",
    attrs: {
      "src": require("../../assets/images/sign/bg-qm.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("点击进入签名")])] : _c('img', {
    ref: "signImg",
    staticClass: "signimg",
    attrs: {
      "src": _vm.url,
      "alt": ""
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "sign_item"
  }, [_c('span', {
    staticClass: "sign_item-label"
  }, [_vm._v("职务：")]), _vm._v(" "), _c('div', [_c('div', {
    on: {
      "click": _vm.toggleRoleListVisible
    }
  }, [_vm._v(_vm._s(_vm.role || '请选择'))])])]), _vm._v(" "), _c('div', {
    staticClass: "sign_item"
  }, [_c('span', {
    staticClass: "sign_item-label"
  }, [_vm._v("电话：")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入11位手机号",
      "readonly": _vm.isSigned
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), (!_vm.isSigned) ? _c('button', {
    staticClass: "confirm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.roleListVisible),
      expression: "roleListVisible"
    }],
    staticClass: "select"
  }, [_c('div', {
    staticClass: "select_body"
  }, [_c('ul', {
    staticClass: "select_body-options"
  }, _vm._l((_vm.roleList), function(item) {
    return _c('li', {
      class: ['select_body-option', {
        selected: item === _vm.tempRole
      }],
      on: {
        "click": function($event) {
          return _vm.changeTempRole(item)
        }
      }
    }, [_vm._v(_vm._s(item) + "\n        ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "select_foot"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeRole(true)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "select_confirm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeRole(false)
      }
    }
  }, [_vm._v("确定")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": require("../../assets/images/sign/icon-lyry.png"),
      "alt": ""
    }
  }), _vm._v("\n        领用人员\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_panel-head"
  }, [_c('div', [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": require("../../assets/images/sign/icon-qm.png"),
      "alt": ""
    }
  }), _vm._v("\n        签名\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a82d9a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sign/Student.vue
// module id = 517
// module chunks = 2